import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecurityService } from '../services/security.service';
import ROUTES from '../config/settings.config';
import { routesConfig } from '../interfaces/interfaces';
import { map, catchError, of } from 'rxjs';

export const routeGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  const _securityService = inject(SecurityService);
  const routes = ROUTES;

  return _securityService.getCheckpoint().pipe(
    map((response: any) => {
      const checkpoint = response.checkpoint;

      const currentRoute = routes.find((route: routesConfig) => 
        route.path.includes(state.url)
      ); 
      
      const allowRoute = [...routes]
        .reverse()
        .find((route: routesConfig) => route.checkpoint.includes(checkpoint));


      if (Number(allowRoute?.step) >= Number(currentRoute?.step)) {
        return true;
      } else {
        _router.navigateByUrl(allowRoute?.path ?? '');
        return false;
      }
    }),
    catchError((error: any) => {
      console.error("Error en el Guard: ", error);
      return of(false);
    })
  );
};